import React from "react";
import { Button, Modal } from "react-materialize";
import StarRatings from "react-star-ratings";
import "../../styles/rating-modal.css";
import $ from "jquery";
import { notify } from "react-notify-toast";
import { alert } from "../Lang";
import store from "store";

export const RatingBlock = ({
	rating_value,
	hover_color,
	rated_color,
	callback,
	...rest
}) => {
	return (
		<div id="rating-block">
			<span id="rating-title">
				{rest.topic}
			</span>
			<StarRatings
				rating={rating_value}
				starRatedColor={rated_color}
				starHoverColor={hover_color}
				starDimension={rest.dimension}
				changeRating={rest.has_reviewed ? null : callback}
				numberOfStars={rest.total_stars}
				name={rest.name}
			/>
		</div>
	);
};
export const CommentBlock = ({ title, label, callback, ...rest }) => {
	return (
		<div id="comment-block">
			<span id="comment-title">
				<h5>{title}</h5>
			</span>
			<textarea
				label={label}
				placeholder={rest.placeholder}
				onChange={callback}
				name={rest.name}
				rows={rest.rows}
				disabled={rest.disabled}
				value={rest.user_comment}
			></textarea>
		</div>
	);
};

class RatingModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};

		props.rating_specs.map(spec => {
			this.state[spec.name] = props.rest.hasReviewed ? props.rest.reviews[spec.name] : 0;
		});
		props.comment_specs.map(spec => {
			this.state[spec.name] = props.rest.hasReviewed ? props.rest.reviews[spec.name] : "";
		});
		this.changeRating = this.changeRating.bind(this);
		this.commentChange = this.commentChange.bind(this);
		this.handleSubmitReview = this.handleSubmitReview.bind(this);
		this.closeRatingModal = this.closeRatingModal.bind(this);
		
	}

	componentDidMount() {
		let { is_open, modal_name } = this.props;
		if (is_open) {
			$("#" + modal_name + "_button").trigger("click");
		}
	}

	changeRating = (newRating, name) => {
		this.state[name] = newRating;
		this.setState({ state: this.state });
	};

	closeRatingModal = e => {
		console.log(store.get(review_state_string));
		let { rating_specs, modal_name } = this.props;
		const item_type = rating_specs[0].item;
		const review_state_string = "review_" + item_type;
		store.remove(review_state_string);
	};

	commentChange = e => {
		const { name, value } = e.target;
		this.setState({ [name]: value });
	};

	handleSubmitReview = e => {
		e.preventDefault();
		const { rating_specs, comment_specs, api_url, callback } = this.props;
		const params = {};
		const item_type = rating_specs[0].item;
		const review_state_string = "review_" + item_type;
		comment_specs.forEach(element => {
			params[element.name] = this.state[element.name];
		});
		const RatingNotValidExpection = 465;
		let rating_error;
		try {
			rating_specs.forEach(element => {
				if (this.state[element.name] === 0) {
					throw RatingNotValidExpection;
				}
				params[element.name] = this.state[element.name];
			});
		} catch (e) {
			if (e === RatingNotValidExpection) {
				rating_error = true;
				notify.show(`${alert.rating_not_valid} `, "warning");
			}
		}
		if (!rating_error) {
			$.post(api_url, params)
				.then(data => {
					notify.show(data.payload, "success");
					store.remove(review_state_string);
					$(".top-right-button")
						.find(".fa-close")
						.trigger("click");
					if (callback) {
						callback();
					}
				})
				.catch(() => {
					notify.show("Course Review not sent due to error", "warning");
				});
		}
	};

	render() {
		let {
			header,
			rating_specs,
			comment_specs,
			modal_name,
			trigger,
			submit_callback
		} = this.props;
		return (
			<div id="outer-rating-modal">
				<Modal
					id={modal_name + "_modal"}
					header={header}
					trigger={<Button id={modal_name + "_button"} className="hide" />}
					modalOptions={{ dismissible: false, scrollable: true }}
				>
					<div className="top-right-button">
						<a className="modal-close" onClick={this.closeRatingModal}>
							<i className="fa fa-close" />
						</a>
					</div>
					<div className="main-wrapper">
						<span className="review-title">
							Bagaimana pengalaman Anda mengikuti kursus <strong className="text-bold">{this.props.rest.courseTitle}</strong>?
						</span>
						{rating_specs &&
							rating_specs.map((spec, index) => (
								<RatingBlock
									key={"ratingBlock-" + index}
									total_stars={5}
									hover_color="#ffbf00"
									rated_color="#ffbf00"
									callback={this.changeRating}
									topic={spec.topic}
									item={spec.item}
									dimension="32px"
									rating_value={this.state[spec.name]}
									name={spec.name}
									courseTitle={this.props.rest.courseTitle}
									has_reviewed={this.props.rest.hasReviewed}
								/>
							))}
						{comment_specs &&
							comment_specs.map((spec, idx) => (
								<CommentBlock
									key={`commentBlock-${idx}`}
									title={spec.title}
									placeholder={spec.placeholder}
									callback={this.commentChange}
									name={spec.name}
									rows={spec.rows}
									disabled={this.props.rest.hasReviewed}
									user_comment={this.props.rest.hasReviewed ? this.state[spec.name] : null}
								/>
							))}
						{
							!this.props.rest.hasReviewed && (
								<div className="button-footer-wrapper">
									<Button id="rating-modal-button" className="btn-cancel modal-close" onClick={this.closeRatingModal}>						
										Batal
									</Button>
									<Button id="rating-modal-button" className="btn-kirim" onClick={this.handleSubmitReview}>						
										Kirim
									</Button>
								</div>
							)
						}
					</div>
				</Modal>
			</div>
		);
	}
}

export default RatingModal;



// WEBPACK FOOTER //
// ./src/components/Reuseables/RatingModal.js